import type { ReactNode } from 'react';
import { Redirect } from 'wouter';
import { useFeature } from '../hooks/useFeature';

interface RouteGateProps {
  feature: string;
  children: ReactNode;
}

// MF-199 — route-level wrapper. Renders children when the named flag is
// enabled for the current user; otherwise redirects to /feature-disabled with
// the key as a query param so the landing page can show which surface was
// gated. Server-side enforcement still happens in middleware/featureFlag.ts.
export function RouteGate({ feature, children }: RouteGateProps) {
  const enabled = useFeature(feature);
  if (!enabled) {
    return <Redirect to={`/feature-disabled?key=${encodeURIComponent(feature)}`} replace />;
  }
  return <>{children}</>;
}
